import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex; /* to fix "baseline space below inline-block element problem" https://stackoverflow.com/q/17905827/1343917 */\n  flex-shrink: 0; /* so that too big width of header text does not change width of avatar */\n'], ['\n  display: flex; /* to fix "baseline space below inline-block element problem" https://stackoverflow.com/q/17905827/1343917 */\n  flex-shrink: 0; /* so that too big width of header text does not change width of avatar */\n']);

import styled from 'styled-components';

var SkeletonIconWrapper = styled.div(_templateObject);

SkeletonIconWrapper.displayName = 'SkeletonIconWrapper';
export default SkeletonIconWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/js/skeleton/styled/SkeletonIconWrapper.js
// module id = 739
// module chunks = 0